export default {
    is_auth_error_handled: false
}